export default {
    "defaultVideos": [
    	{
            "title": "Hallicunations: Mr. van Elburg",
            "assets": {
                "imageURL": "shared/algemeen0.jpg",
                "videoURL": "algemeen0.flv"
            }
        },
        {
            "title": "Milk churners: Mr. Kersten",
            "assets": {
                "imageURL": "shared/algemeen1.jpg",
                "videoURL": "algemeen1.flv"
            }
        },
        {
            "title": "The walk: Mr. Kersten",
            "assets": {
                "imageURL": "shared/algemeen2.jpg",
                "videoURL": "algemeen2.flv"
            }
        }
    ],
    "videos": [
        {
            "id": "acties.actie.communiceren.orientatievragenstellen.tip",
            "title": "Asking orienting questions: Mr. van Elburg",
            "assets": {
                "imageURL": "shared/orientatievragenstellen.jpg",
                "videoURL": "orientatievragenstellen.flv"
            }
        },
        {
            "id": "acties.actie.communiceren.patientvragennaardenacht.tip",
            "title": "Party: Mr. de Vries",
            "assets": {
                "imageURL": "shared/patientvragennaardenacht.jpg",
                "videoURL": "patientvragennaardenacht.flv"
            }
        },
        {
            "id": "acties.actie.communiceren.patientvragennaarnachtrust.tip",
            "title": "Dark Figures: Mr. van Blankers",
            "assets": {
                "imageURL": "shared/patientvragennaarnachtrust.jpg",
                "videoURL": "patientvragennaarnachtrust.flv"
            }
        },
        {
            "id": "acties.actie.communiceren.patientwijzenoprealiteit.tip",
            "title": "Point out reality: Mr. van Elburg",
            "assets": {
                "imageURL": "shared/patientwijzenoprealiteit0.jpg",
                "videoURL": "patientwijzenoprealiteit0.flv"
            }
        },
        {
            "id": "acties.actie.communiceren.vragenofdepatientweetwaarhijis.tip",
            "title": "Do you know where you are?: Mr. van Blankers",
            "assets": {
                "imageURL": "shared/vragenofdepatientweetwaarhijis.jpg",
                "videoURL": "vragenofdepatientweetwaarhijis.flv"
            }
        },
        {
            "id": "acties.actie.communiceren.vragenwatdepatientheeftgezien.tip",
            "title": "Shades: Mr. de Vries",
            "assets": {
                "imageURL": "shared/vragenwatdepatientheeftgezien.jpg",
                "videoURL": "vragenwatdepatientheeftgezien.flv"
            }
        },
        {
            "id": "acties.actie.klok.klokweghalen.tip",
            "title": "The clock: Mr. Kersten",
            "assets": {
                "imageURL": "shared/klokweghalen.jpg",
                "videoURL": "klokweghalen.flv"
            }
        },
        {
            "id": "acties.actie.medicatietoedienen.medicatietoelichtenaanpatient.tip",
            "title": "Burnt Chicken: Mrs. Nieuwenhuis",
            "assets": {
                "imageURL": "shared/medicatietoelichtenaanpatient.jpg",
                "videoURL": "medicatietoelichtenaanpatient.flv"
            }
        },
        {
            "id": "acties.actie.whiteboard.uitvegen.tip",
            "title": "White board: Mr. van Blankers",
            "assets": {
                "imageURL": "shared/whiteboarduitvegen.jpg",
                "videoURL": "whiteboarduitvegen0.flv"
            }
        },
        {
            "id": "acties.actie.zweedseband.controlerenofzweedsebandvolgensprotocolisaangelegd.tip",
            "title": "Bed restraints: Mrs. Nieuwenhuis",
            "assets": {
                "imageURL": "shared/controlerenofzweedsebandvolgensprotocolisaangelegd.jpg",
                "videoURL": "controlerenofzweedsebandvolgensprotocolisaangelegd.flv"
            }
        },
        {
            "id": "acties.actie.zweedseband.zweedsebanduitdoenwanneerpartnerarriveert.tip",
            "title": "Bed restraints: Mr. Kersten",
            "assets": {
                "imageURL": "shared/zweedsebanduitdoenwanneerpartnerarriveert.jpg",
                "videoURL": "zweedsebanduitdoenwanneerpartnerarriveert.flv"
            }
        }
    ]
}